import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RealityCheckNewValueConfirmationPopupDescription = withConfig(theme => styled('div', { label: 'RealityCheckNewValueConfirmationPopupDescription' })`
    font-size: ${theme.star.fontSize.xRegular};
    margin: 4px 0 16px 0;
`);
